import React from 'react';

import {HStack, Text, VStack, Badge} from "@chakra-ui/react";
import {format} from "date-fns";

import {useLanguage} from "@/contexts/languageContext";
import {Skeleton} from "@/components";
import stringUtil from "@/utils/stringUtil";
import dateUtil from "@/utils/dateUtil";

export const ArticleBodySkeleton = ({props}) => {
    return <HStack
        gap="1vw"
        minH="3.5rem"
        overflow="hidden"
        flex={1}
        {...props}
    >
        <VStack align="flex-start" flex={1} overflow="hidden">
            <Skeleton>
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                >
                    { stringUtil.getRandomString(50, 80) }
                </Text>
            </Skeleton>
            <HStack>
                {
                    Array.from({length: Math.floor(Math.random() * 6)}).map((_, i) => {
                        return <Skeleton key={`art-body-ske-${i}`}>
                            <Badge fontSize="0.8em">
                                { stringUtil.getRandomString(7, 12) }
                            </Badge>
                        </Skeleton>
                    })
                }
            </HStack>
            <Skeleton>
                <Text
                    fontSize="sm"
                    isTruncated
                >
                    { stringUtil.getRandomString(20, 30) }
                </Text>
            </Skeleton>
        </VStack>
        <Skeleton>
            <Badge fontSize=".8em">publié</Badge>
        </Skeleton>
    </HStack>
}

export const ArticleBody = ({element, ...props}) => {
    const {language: uiLanguage, t, availableLanguages} = useLanguage();
    const displayLang = element?.displayLanguage || uiLanguage;

    return (
        <HStack
            gap="1vw"
            minH="3.5rem"
            color={element.deleted ? "gray.400" : "secondary.500"}
            overflow="hidden"
            {...props}
        >
            <VStack align="flex-start" flex={1} overflow="hidden">
                <HStack>
                    <Text
                        fontWeight="bold"
                        fontSize="md"
                        isTruncated
                        color={element.deleted ? "gray.400" : "inherit"}
                    >
                        {element[`${displayLang}Title`] && element[`${displayLang}Title`].length > 0 ? element[`${displayLang}Title`] : (element[`frTitle`]?.length > 0 ? element[`frTitle`] : element[`enTitle`])}
                    </Text>
                    {availableLanguages.map((lang) => {
                        if (element[`${lang}Title`] && element[`${lang}Title`].length > 0) {
                            return <Text key={lang}>{lang === 'fr' ? '🇫🇷' : '🇬🇧'}</Text>
                        }
                        return null;
                    })}
                </HStack>
                <HStack>
                    {
                        element.tags.map((tag, i) => {
                            return <Badge
                                key={`art-tag-${i}`}
                                fontSize="0.8em"
                                bg={tag?.color?.background}
                                color={tag?.color?.text}
                            >
                                { tag?.[displayLang] }
                            </Badge>
                        })
                    }
                </HStack>
                <Text
                    fontSize="sm"
                    color="secondary.500"
                    isTruncated
                >
                    {`${t('misc.publishedAt')} ${dateUtil.format(new Date(element?.publishedAt), uiLanguage === 'fr' ? 'fr-FR' : 'en-US', {
                        day: 'numeric',
                        month: 'numeric',
                        year: 'numeric'
                    }, '/')} ${t('misc.by')} ${element?.firstnameUser} ${element?.lastnameUser}`}
                </Text>
            </VStack>
            <Badge
                colorPalette={
                    element.deleted ? "red" : "green"
                }
                fontSize="0.8em"
            >
                {element.deleted ? t('states.notPublished') : t('states.published')}
            </Badge>
        </HStack>
    );
};

export default ArticleBody;
